import { render } from "./ReportsSidebarStatic.vue?vue&type=template&id=57e38db4"
import script from "./ReportsSidebarStatic.vue?vue&type=script&lang=js"
export * from "./ReportsSidebarStatic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__